import Crud from '../components/CategoryProduct/Crud'
import Edit from '../components/CategoryProduct/Edit'

let routes = {
    path: '/categoryProduct',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {            
            path: '/categoryProduct',
            component: Crud
        },
        {            
            path: '/categoryProduct/edit/:id',
            component: Edit
        }
    ]        
}


export default routes


// WEBPACK FOOTER //
// ./src/router/categoryProduct.js